import linkViewModel from '@vimcar/mvvm/linkViewModel'
import AutoComplete from '@vimcar/shared-components/components/AutoComplete'
import IForm from '@vimcar/shared-components/components/IForm/'
import TextField from '@vimcar/shared-components/components/IForm/components/TextField'
import Paragraph from '@vimcar/shared-components/components/Paragraph'
import * as React from 'react'

import type { ViewState } from '../Root/viewModel'
import type { ViewModel } from './viewModel'

import i18n from '../../utils/i18n'
import BottomActions from '../BottomActions'
import SelectField from '../IFormComponents/SelectField'
import StepContent from '../StepContent'
import styles from './styles.css'
import mkViewModel from './viewModel'

const tp = i18n.prefixWithoutTestId('CustomCarInput')

type Props = {
  state: ViewState
  viewModel: ViewModel
}

const CustomCarInput = ({ state, viewModel }: Props) => (
  <React.Fragment>
    <StepContent>
      <Paragraph variant='subtitle1'>{state.currentNode.text}</Paragraph>
      <Paragraph variant='body2'>{state.currentNode.subtext}</Paragraph>
      {/* @ts-expect-error@2322 */}
      <IForm
        className={styles.form}
        data={viewModel.data}
        onChange={viewModel.handleFormChange}
      >
        {viewModel.availableCars.length <= 1 && (
          // @ts-expect-error@2322
          <TextField label={tp('affected-car')} property='affectedCar' />
        )}
        {viewModel.availableCars.length > 1 && (
          <AutoComplete
            dataSource={viewModel.carDataSource}
            inputProps={{
              errorText: viewModel.errorText,
              floatingLabelText: tp('affected-car'),
            }}
            onChange={viewModel.handleAutocompleteChange}
            onSelect={viewModel.handleAutocompleteSelect}
          />
        )}
      </IForm>
    </StepContent>
    <BottomActions
      onBack={viewModel.handleBack}
      // @ts-expect-error@2322
      onNext={viewModel.handleNext}
      showBack
    />
  </React.Fragment>
)

const component = linkViewModel(mkViewModel, CustomCarInput)
component.displayName = 'CustomCarInput'
export default component
